import {ModuleProto} from "../../module-proto";
import {ModuleType} from "../../types";
import googleDriveConnect from "../../../../app/integrations/settings/gdrive/actions/connect";
import ApiIntegrationGoogleDrive from "../../../gd/api/integrations/google-drive";
import {SettingsMenuTopCategory} from "../../settings-module";
import {SettingsParentSection} from "../../../../app/settings/const";

// const debug = "GoogleDriveModule"
const debug = false

export class GoogleDriveModule extends ModuleProto {

    public account            : string | null
    public domainName         : string | null
    private _rootFolder?      : string | undefined

    constructor() {
        super(ModuleType.GOOGLE_DRIVE, {});

        debug && console.log(debug, "constructor() moduleConfig=", {})

        const googleDriveConfig = gd.session.modules.get(gd.companyId)?.gDrive

        this.name                    = "Google drive"
        this.description             = "Connect GoodDay to your Google Drive account to attach, share, upload and collaborate on files directly in your Drive."
        this.svgIcon                 = "isvg-gdrive"
        this.settingsMenuTopCategory = SettingsMenuTopCategory.INTEGRATIONS
        this.typeLabel               = "Integration"
        this.parentSection              = SettingsParentSection.INTEGRATIONS

        this._isEnabled              = !!googleDriveConfig

        this.account                 = null
        this.domainName              = null
        this._rootFolder             = ""

        this.settingsUrl             = "settings/integrations/gdrive"


        debug && console.log(debug, "_isEnabled", this._isEnabled)
    }

    enable = async () => {
        try {
            // await new Request(this, 'POST', `company/${gd.companyId}/integrations/g-drive`);
            // super.enable();
            googleDriveConnect()
        }catch (e){
            console.log(e)
        }
        gd.modules.saveConfig()
    }

    disable= async () =>{
        try {

            gd.layout.loading.showAppBusy(async ()=>{

                await ApiIntegrationGoogleDrive.disable().promise()

                // we need reRender & restart
                gd.getApp().start()

            })

            // super.disable(); - DO NOT CALL SUPER HERE !!!

        } catch (e){
            console.log(e)
        }
    }

    get rootFolder(){
        if (this._rootFolder === undefined) {
            throw Error("#9d898378 Try access without init")
        }
        return this._rootFolder
    }

    set rootFolder(rootFolder:string) {
        this._rootFolder = rootFolder
    }

    toJson() {
        debug && console.log(debug, "toJson() type=",this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }
}
